let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dKJMA")).then(() => parcelRequire('kjE4G'));